import * as React from 'react';
import {getReactButton} from "../../index";

export interface ReactCheckboxData {
    id?: string,
    onClick?: (rowOBJ: any, shiftKey: boolean, ctrlKey: boolean, rowIndex: number) => void,
    row: any,
    disabled?: boolean,
    label?: string,
    css?: string,
    style?: {},
    labelStyle?: {},
    disableID?: string,
    refreshID?: string,
    onRefresh?: () => {},
    dataKey: string,
    tabIndex?: null,
    rowIndex?: number,
    title?: string,
    stopPropagationOnClick?: boolean,
}

export interface ReactCheckboxState {
    row: any,
    disabled: boolean,
}

export class ReactCheckbox extends React.Component<ReactCheckboxData> {
    constructor(props: ReactCheckboxData) {
        super(props);

        this.state = {row: props.row, disabled: props.disabled};

        // Binding is necessary to allow these functions access to the State data
        this.handleChange = this.handleChange.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactCheckboxData) {
        this.setState({
            row: props.row,
            disabled: props.disabled
        });
    }

    handleChange(event: React.MouseEvent<HTMLInputElement, MouseEvent>) {
        this.setState(() => {
            if(null != (this.state as ReactCheckboxState).row[this.props.dataKey] && 'undefined' != (this.state as ReactCheckboxState).row[this.props.dataKey]) {
                (this.state as ReactCheckboxState).row[this.props.dataKey] = !(this.state as ReactCheckboxState).row[this.props.dataKey];
            } else {
                (this.state as ReactCheckboxState).row[this.props.dataKey] = true;
            }

            return {
                row: (this.state as ReactCheckboxState).row
            }
        }, () => {
            if (null != this.props.onClick) {
                this.props.onClick((this.state as ReactCheckboxState).row, event.shiftKey, event.ctrlKey, this.props.rowIndex);
            }
        });

        if(null != this.props.stopPropagationOnClick && this.props.stopPropagationOnClick) {
            event.stopPropagation();
        }
    }

    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState(() => ({
            row: (this.state as ReactCheckboxState).row,
        }));
    }

    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    getCheckbox() {
        if(this.props.title) {
            return <input
                id={this.props.id}
                type="checkbox"
                tabIndex={this.props.tabIndex}
                onClick={this.handleChange}
                checked={(null != (this.state as ReactCheckboxState).row[this.props.dataKey] && 'undefined' != (this.state as ReactCheckboxState).row[this.props.dataKey]) ? (this.state as ReactCheckboxState).row[this.props.dataKey] : false}
                disabled={(this.state as ReactCheckboxState).disabled}
                title={this.props.title}
            />
        } else {
            return <input
                id={this.props.id}
                type="checkbox"
                tabIndex={this.props.tabIndex}
                onClick={this.handleChange}
                checked={(null != (this.state as ReactCheckboxState).row[this.props.dataKey] && 'undefined' != (this.state as ReactCheckboxState).row[this.props.dataKey]) ? (this.state as ReactCheckboxState).row[this.props.dataKey] : false}
                disabled={(this.state as ReactCheckboxState).disabled}
            />
        }
    }

    render() {
        return <React.Fragment>
            {<table className="categoryAllHide"><tr>
                <td><input
                    id={this.props.disableID}
                    type="checkbox"
                    onChange={this.onDisableClick}
                    checked={(this.state as ReactCheckboxState).disabled}
                /></td>
                <td>
                    HIDDEN DISABLE BUTTON
                </td>
            </tr></table>
            }
            {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
            <table className={this.props.css} style={this.props.style}><tr>
                <td>
                    {this.getCheckbox()}
                </td>
                <td>{(this.props.label != '') ? <label htmlFor={this.props.id} style={this.props.labelStyle}><span className="clickable">{this.props.label}</span></label> : null}</td>
            </tr></table>
        </React.Fragment>;
    }
}
